export default __webpack_public_path__ + "static/media/SASRIA Motor-Policy-2026.b5d288af.pdf";